@if(!IsTenantConfiguration && data.IsShowOnScreen && data.Value !== undefined && data.Value !== null && data.Value !== ''){
<div class="notice bg-light-primary rounded border-primary border border-dashed min-w-lg-600px flex-shrink-0 p-6 mt-5" > 
    <div class="row m-heading-1 border-green m-bordered">
        <p class="p-0 m-0">
            <strong>{{ 'TRANSLATE.PRICING_API_CONSENT_VIEW_INSTRUCTIONS_HEADING' | translate }}</strong>
        </p>
        <ul class="ps-10 pt-4">
            <li>
                <span class="text-primary cursor-pointer" (click)="confirmCopy()">{{ 'TRANSLATE.CPV_CONSENT_VIEW_INSTRUCTIONS_5' | translate }}</span>        
                    <span>{{ 'TRANSLATE.PRICING_API_VIEW_INSTRUCTIONS_1' | translate }}</span>
            </li>
            <li>
                {{ 'TRANSLATE.PRICING_API_VIEW_INSTRUCTIONS_2' | translate }}
            </li>
            <li>
                {{ 'TRANSLATE.PRICING_API_VIEW_INSTRUCTIONS_3' | translate }}
            </li>
        </ul>
    </div>
    <!--Test Microsoft Pricing API consent-->
    <div class="col-md-12 control-label">
        <button class="btn btn-sm fw-bold btn-primary m-2" (click)="testMicrosoftPricingAPIAccess()" [disabled]="isBusy">
            <!-- <ng-container *ngIf="isBusy">
                <i class="fa fa-refresh fa-spin"></i>
                {{ 'TRANSLATE.BUSY_MESSAGE_TEXT_PLEASE_WAIT' | translate }}
            </ng-container> -->
            <ng-container >
                {{ 'TRANSLATE.TEST_MICROSOFT_PRICING_API_CONSENT_ACCESS_BTN_TEXT' | translate }}
            </ng-container>
        </button>
        <span>{{ 'TRANSLATE.ACCEPT_THE_MICROSOFT_PRICING_API_CONSENT_BTN_TEXT' | translate }}</span>
    </div>
</div>
}
